export default {"src":"/uk/_next/static/media/alertIcon.9873bdb2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};